import { Transform } from 'class-transformer';
import { stringToBooleanNullable } from '../../types-transformers/boolean-transformers';
import { SystemSettingsEnum } from '../../enums';

export class SystemSettingsFilter {
	public keys: SystemSettingsEnum[];

	@Transform(stringToBooleanNullable)
	public isPublic?: boolean;
}
